import { render, staticRenderFns } from "./Dasboard.vue?vue&type=template&id=e676a4c0&scoped=true&"
import script from "./Dasboard.vue?vue&type=script&lang=js&"
export * from "./Dasboard.vue?vue&type=script&lang=js&"
import style0 from "./Dasboard.vue?vue&type=style&index=0&id=e676a4c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e676a4c0",
  null
  
)

export default component.exports